<template>
    <div v-if="isVisible" class="guide-tour" @keyup.esc="skipTour" tabindex="0">
        <!-- Karanlık Arkaplan -->
        <div class="guide-overlay"></div>

        <!-- Fokus Alanı (Daha Geniş ve Yuvarlak) -->
        <div v-if="currentStep" class="guide-focus" :style="focusStyle"></div>

        <!-- Mesaj Kutusu (Merkezde) -->
        <div v-if="currentStep" class="guide-message">
            <div class="message-content">
                <p>{{ currentStep.message }}</p>
                <div class="guide-controls">
                    <SupsisButton @click="previousStep" :disabled="currentStepIndex === 0" ghost primary xlarge>
                        {{ $t("guideTour.back") }}
                        <span class="shortcut">{{ $t("guideTour.shortcutHintLeft") }}</span>
                    </SupsisButton>
                    <SupsisButton @click="skipTour" ghost primary xlarge>
                        {{ $t("guideTour.skip") }}
                        <span class="shortcut">{{ $t("guideTour.shortcutHintEsc") }}</span>
                    </SupsisButton>
                    <SupsisButton @click="nextStep" :primary="isLastStep" ghost xlarge>
                        {{ isLastStep ? $t("guideTour.finish") : $t("guideTour.next") }}
                        <span class="shortcut">{{ $t("guideTour.shortcutHintRight") }}</span>
                    </SupsisButton>
                </div>
            </div>
        </div>

        <!-- Spiral Ok (Mesaj Alanından Fokus Alanına) -->
        <div
            class="guide-arrow"
            v-if="arrowStyle.display"
            :style="{
                top: arrowStyle.top + 'px',
                left: arrowStyle.left + 'px',
                width: arrowStyle.width + 'px',
                height: arrowStyle.height + 'px',
            }"
        >
            <svg
                :width="arrowStyle.width"
                :height="arrowStyle.height"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                stroke="url(#arrowGradient)"
                stroke-width="3"
            >
                <!-- Gradient tanımı -->
                <defs>
                    <linearGradient id="arrowGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" style="stop-color: #ff6b6b" />
                        <stop offset="50%" style="stop-color: #4ecdc4" />
                        <stop offset="100%" style="stop-color: #45b7d1" />
                    </linearGradient>
                </defs>

                <!-- Spiral benzeri kavis -->
                <path :d="arrowPath" stroke-linecap="round" stroke-linejoin="round" />

                <!-- Ok ucu -->
                <polygon v-if="arrowHeadPoints" :points="arrowHeadPoints" fill="url(#arrowGradient)" stroke="none" />
            </svg>
        </div>
    </div>
</template>

<script>
import SupsisButton from "../../views/Pages/Settings/components/SupsisButton.vue";
import SYSTEM_PUBSUB from "../../utils/systemPubSub";

export default {
    name: "GuideTour",
    components: {
        SupsisButton,
    },
    data() {
        return {
            isVisible: false,
            currentStepIndex: 0,
            completedTourKeys: [],
            singleMode: false,
            availableSteps: [],
            dynamicSteps: [],
            builtinStepDefs: [
                {
                    id: "app-switcher-intro",
                    path: "/chat",
                    el: ".app-switcher-button",
                    messageKey: "guideTour.appSwitcherIntro",
                },
                {
                    id: "profile-button",
                    path: "/chat",
                    el: ".dropdown-control-item.profile",
                    messageKey: "guideTour.profileButton",
                },
                {
                    id: "settings-button",
                    path: "/chat",
                    el: ".dropdown-control-item.settings",
                    messageKey: "guideTour.settingsButton",
                },
                {
                    id: "integrations-button",
                    path: "/chat",
                    el: ".dropdown-control-item.integrations",
                    messageKey: "guideTour.integrationsButton",
                },
                {
                    id: "sidebar-menu",
                    path: "/chat",
                    el: ".sidebar-menu",
                    messageKey: "guideTour.sidebarMenu",
                },
                {
                    id: "helper-menu",
                    path: "/chat",
                    el: "#popoverHelpMenu",
                    messageKey: "guideTour.helperMenu",
                },
                {
                    id: "search-bar",
                    path: "/chat",
                    el: "#search-bar",
                    messageKey: "guideTour.searchBar",
                },
                {
                    id: "chat-filter",
                    path: "/chat",
                    el: ".contact-filters-toolbar > .add-button",
                    messageKey: "guideTour.chatFilterWorklist",
                },
                {
                    id: "chat-filter",
                    path: "/chat",
                    el: ".filters > .add-button",
                    messageKey: "guideTour.chatFilterWorklist",
                },
                {
                    id: "chat-sort",
                    path: "/chat",
                    el: ".chat-btn.add-sort-button",
                    messageKey: "guideTour.chatSort",
                },
                {
                    id: "chat-group",
                    path: "/chat",
                    el: ".chat-btn.add-group-button",
                    messageKey: "guideTour.chatGroup",
                },
                {
                    id: "chat-contact-switch",
                    path: "/chat",
                    el: ".btn-contact-switch",
                    messageKey: "guideTour.chatContactSwitchLive",
                },
                {
                    id: "chat-contact-switch",
                    path: "/chat",
                    el: ".btn-sidebar-navigation",
                    messageKey: "guideTour.chatSidebarToggle",
                },
                {
                    id: "chat-team-chat",
                    path: "/chat",
                    el: '[data-menukey="teamChat"]',
                    messageKey: "guideTour.chatTeamChat",
                },
            ],
            focusStyle: {
                top: "0px",
                left: "0px",
                width: "0px",
                height: "0px",
            },
            arrowStyle: {
                display: false,
                top: 0,
                left: 0,
                width: 0,
                height: 0,
            },
            arrowPath: "",
            arrowHeadPoints: "",
        };
    },
    computed: {
        allSteps() {
            var vm = this;
            var builtin = [];
            var i;
            for (i = 0; i < this.builtinStepDefs.length; i++) {
                var d = this.builtinStepDefs[i];
                builtin.push({
                    id: d.id,
                    path: d.path,
                    el: d.el,
                    message: vm.$t(d.messageKey),
                });
            }
            return builtin.concat(this.dynamicSteps);
        },
        currentStep() {
            return this.availableSteps[this.currentStepIndex];
        },
        isLastStep() {
            return this.currentStepIndex === this.availableSteps.length - 1;
        },
    },
    methods: {
        buildAvailableSteps() {
            var currentPath = this.$route.path;
            var self = this;
            return this.allSteps.filter(function (step) {
                var isPathMatch = step.path === currentPath || step.path === "/";
                var isCompleted = self.completedTourKeys.indexOf(step.id) !== -1;
                var singleModeMatched = self.singleMode ? step.singleMode : true;
                return isPathMatch && !isCompleted && singleModeMatched;
            });
        },
        checkVisibility() {
            if (!this.allSteps.length) {
                return false;
            }

            var savedTours = localStorage.getItem("completedTourKeys");
            this.completedTourKeys = savedTours ? JSON.parse(savedTours) : [];

            var nextAvailable = this.buildAvailableSteps();

            if (nextAvailable.length) {
                if (this.currentStepIndex >= nextAvailable.length) {
                    this.currentStepIndex = 0;
                }
                this.isVisible = true;
                this.availableSteps = nextAvailable;
                this.$nextTick(() => {
                    this.updateFocusElement();
                });
            } else {
                this.isVisible = false;
                this.availableSteps = [];
            }
        },
        updateFocusElement() {
            if (!this.currentStep) {
                return;
            }
            var element = document.querySelector(this.currentStep.el);
            if (!element) {
                return;
            }

            var rect = element.getBoundingClientRect();

            // Delik boyutu artırmak için ekstra padding
            var FOCUS_PADDING = 200;
            var diameter = Math.max(rect.width, rect.height) + FOCUS_PADDING * 2;

            // Yuvarlak fokus alanı
            this.focusStyle = {
                position: "fixed",
                top: rect.top + rect.height / 2 - diameter / 2 + "px",
                left: rect.left + rect.width / 2 - diameter / 2 + "px",
                width: diameter + "px",
                height: diameter + "px",
                boxShadow: "0 0 0 9999px rgba(0, 0, 0, 0.85)",
                borderRadius: "50%",
                pointerEvents: "none",
            };

            this.$nextTick(() => {
                this.updateArrow(rect);
            });
        },
        updateArrow(focusRect) {
            // Fokus alanının merkezi
            var focusCenterX = focusRect.left + focusRect.width / 2;
            var focusCenterY = focusRect.top + focusRect.height / 2;

            // Mesaj kutusunu bul
            if (!this.$el) return;
            var messageEl = this.$el.querySelector(".guide-message");
            if (!messageEl) {
                this.arrowStyle.display = false;
                return;
            }
            var messageRect = messageEl.getBoundingClientRect();

            // Mesaj kutusunun 4 köşesini hesapla
            var corners = [
                { x: messageRect.left, y: messageRect.top },
                { x: messageRect.right, y: messageRect.top },
                { x: messageRect.left, y: messageRect.bottom },
                { x: messageRect.right, y: messageRect.bottom },
            ];

            // Fokus alanına en yakın köşeyi bulalım
            var closestCorner = corners[0];
            var minDist = this.getDistance(corners[0].x, corners[0].y, focusCenterX, focusCenterY);

            for (var i = 1; i < corners.length; i++) {
                var dist = this.getDistance(corners[i].x, corners[i].y, focusCenterX, focusCenterY);
                if (dist < minDist) {
                    minDist = dist;
                    closestCorner = corners[i];
                }
            }

            // Ok başlangıç noktası en yakın köşe
            var startX = closestCorner.x;
            var startY = closestCorner.y;

            // Ok bitiş noktası fokus alanı merkezi
            var endX = focusCenterX;
            var endY = focusCenterY;

            // SVG kutusunun konumu
            var boxLeft = Math.min(startX, endX);
            var boxTop = Math.min(startY, endY);
            var boxWidth = Math.abs(endX - startX);
            var boxHeight = Math.abs(endY - startY);

            this.arrowStyle.display = true;
            this.arrowStyle.top = boxTop;
            this.arrowStyle.left = boxLeft;
            this.arrowStyle.width = boxWidth;
            this.arrowStyle.height = boxHeight;

            // Lokal koordinatlar
            var localStartX = startX - boxLeft;
            var localStartY = startY - boxTop;
            var localEndX = endX - boxLeft;
            var localEndY = endY - boxTop;

            // Spiral benzeri bir kavis oluşturmak için basit bir kontrol noktası
            var midX = (localStartX + localEndX) / 2;
            var midY = (localStartY + localEndY) / 2;
            var curveOffset = 40;
            var controlX = midX + curveOffset;
            var controlY = midY - curveOffset;

            // Q bezier (spirale kavis vermek için)
            this.arrowPath =
                "M " +
                localStartX +
                " " +
                localStartY +
                " Q " +
                controlX +
                " " +
                controlY +
                " " +
                localEndX +
                " " +
                localEndY;

            // Ok ucu - boyutu artırıldı
            var arrowSize = 12; // 8'den 12'ye çıkarıldı
            var angle = Math.atan2(localEndY - localStartY, localEndX - localStartX);
            var arrowLeftX = localEndX - arrowSize * Math.cos(angle + 0.4); // Açı biraz daha genişletildi
            var arrowLeftY = localEndY - arrowSize * Math.sin(angle + 0.4);
            var arrowRightX = localEndX - arrowSize * Math.cos(angle - 0.4);
            var arrowRightY = localEndY - arrowSize * Math.sin(angle - 0.4);

            this.arrowHeadPoints =
                localEndX +
                "," +
                localEndY +
                " " +
                arrowLeftX +
                "," +
                arrowLeftY +
                " " +
                arrowRightX +
                "," +
                arrowRightY;
        },
        getDistance(x1, y1, x2, y2) {
            var dx = x2 - x1;
            var dy = y2 - y1;
            return Math.sqrt(dx * dx + dy * dy);
        },
        nextStep() {
            if (this.isLastStep) {
                this.completeTour();
            } else {
                this.currentStepIndex++;
                this.$nextTick(() => {
                    this.updateFocusElement();
                });
            }
        },
        previousStep() {
            if (this.currentStepIndex > 0) {
                this.currentStepIndex--;
                this.$nextTick(() => {
                    this.updateFocusElement();
                });
            }
        },
        skipTour() {
            this.completeTour();
        },
        completeTour() {
            this.availableSteps.forEach((step) => {
                if (!this.completedTourKeys.includes(step.id)) {
                    this.completedTourKeys.push(step.id);
                }
            });

            localStorage.setItem("completedTourKeys", JSON.stringify(this.completedTourKeys));
            this.isVisible = false;
        },
        handleKeyPress(e) {
            if (e.key === "ArrowRight") {
                this.nextStep();
            } else if (e.key === "ArrowLeft") {
                this.previousStep();
            } else if (e.key === "Escape") {
                this.skipTour();
            }
        },
        listenToSystemPubSub() {
            this.sub = SYSTEM_PUBSUB.stream.subscribe(({ type, payload }) => {
                if (type === SYSTEM_PUBSUB.MESSAGE_TYPES.SHOW_SINGLE_GUIDE_TOUR) {
                    payload.singleMode = true;
                    this.singleMode = true;
                    this.dynamicSteps.push(payload);
                    this.checkVisibility();
                }
            });
        },
        showIfNeeded() {
            var self = this;
            setTimeout(function () {
                const isAnyModalExists = Array.from(document.querySelectorAll(".ant-modal-root")).filter((modal) => {
                    return modal.style.display !== "none";
                }).length > 0;
                if (!isAnyModalExists) {
                    self.checkVisibility();
                    window.addEventListener("resize", self.updateFocusElement);
                    self.updateFocusElement();
                    setTimeout(function () {
                        self.updateFocusElement();
                    }, 100);
                } else {
                    setTimeout(() => {
                        self.showIfNeeded();
                    }, 1000 * 5);
                }
            }, 1000);
        },
    },
    mounted() {
        this.listenToSystemPubSub();
    },
    created() {
        this.showIfNeeded();
        window.addEventListener("keydown", this.handleKeyPress);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.updateFocusElement);
        window.removeEventListener("keydown", this.handleKeyPress);
        this.sub.unsubscribe();
    },
    watch: {
        $route() {
            this.checkVisibility();
        },
        "$i18n.locale": function () {
            if (this.isVisible) {
                this.availableSteps = this.buildAvailableSteps();
                this.$nextTick(() => {
                    this.updateFocusElement();
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.guide-tour {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    pointer-events: none;
}

// Karanlık Arkaplan
.guide-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
}

// Fokus Alanı
.guide-focus {
    position: absolute;
    transition: all 0.15s ease;
    pointer-events: none;
}

// Mesaj Kutusu (Orta Ekran)
.guide-message {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    pointer-events: auto; // Butonların tıklanabilmesi için
    background: transparent; // Kutu görünmesin
    color: #ffffff; // Yazılar beyaz
    max-width: 600px;

    .message-content {
        //font-family: cursive; // Kıvrımlı bir yazı stili
        font-size: 24px;
        padding: 16px 0;

        p {
            margin-bottom: 16px;
            line-height: 1.5;
        }

        .guide-controls {
            display: flex;
            justify-content: space-between;
            gap: 8px;

            button {
                flex: 1;
            }

            .supsis-button {
                border: 1px solid white;
                color: white;
            }

            .shortcut {
                font-size: 12px;
                opacity: 0.7;
                margin-left: 4px;
                color: white;
            }
        }
    }
}

// Spiral Ok
.guide-arrow {
    position: absolute;
    pointer-events: none;
    z-index: 2;

    svg {
        overflow: visible;
    }
}

// Klavye odağı için outline'ı gizle
.guide-tour:focus {
    outline: none;
}
</style>
